import styled, { css } from 'styled-components'
import { breakpoint } from '../layout/styles'

export const Cta = styled.a<any>`
  display: inline-block;
  max-width: 70vw;
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: none;
  color: var(--text);
  font-size: 1.125rem;
  line-height: 1.5rem;
  padding-right: 3rem;
  cursor: pointer;
  max-width: fit-content;
  background: url(/images/cta${props => (props.forceLight || props.light) ? '-light' : ''}.svg) no-repeat right center;
  ${props => (props.forceLight || props.light) && css`
    color: white;
  `};
  @media ${breakpoint.mobile} {
    ${props => (props.second) && css`
      margin-top: 1rem;
    `
  }}

  @media ${breakpoint.tablet} {
    ${props => (props.second) && css`
      margin: 0 0 0 1.5rem;
    `
  }}
  ${props => (props.blue) && css`
    &&& {
      background-color: var(--lightblue) !important;
      color: var(--black) !important;
    }
  `}
  ${props => props.dark && css`
    &&& {
      background-color: var(--black);
      color: var(--white);
    }
  `}
  ${props => props.ocean && css`
    &&& {
      background-color: var(--ocean) !important;
      color: var(--black) !important;
    }
  `}
  ${props => props.warm_orange && css`
    &&& {
      background-color: var(--warm-orange) !important;
      color: var(--white) !important;
    }
  `}
  ${props => props.light && css`
    &&& {
      color: var(--white) !important;
    }
  `}
  ${props => props.white && css`
    &&& {
      background-color: var(--white) !important;
      color: var(--black) !important;
    }
  `}
  @media ${breakpoint.desktop} {
    background-image: url(/images/cta${props => props.light ? '-light' : ''}.svg);
  }
  transition: padding-right 350ms ease;
  @media (hover: hover) {
    &:hover {
      padding-right: 4rem;
    }
  }
  span {
    display: none;
  }
`

export const InvertedCta = styled.a<any>`
  display: inline-block;
  margin: 4px 0;
  text-transform: uppercase;
  font-weight: bold;
  text-decoration: none;
  color: var(--text);
  font-size: 1.125rem;
  line-height: 1.5rem;
  padding-left: 3rem;
  cursor: pointer;
  background: url(/images/cta-inverted${props => props.light ? '-light' : ''}.svg) no-repeat left center;
  transition: padding-right 350ms ease;
  @media (hover: hover) {
    &:hover {
      padding-right: 4rem;
    }
  }
  span {
    display: none;
  }
`

export default Cta